import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

class MobileSelectedFacets extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        const { attributes, onAttributeChange, onClearAttributes } = this.props;

        const selectedAttributeValueArrays = attributes.map(function (attribute) {
            return attribute.Values.filter(
                value => value.Checked).map(value => {
                    return {
                        attributeName: attribute.Name,
                        attributeValueName: value.Name
                    };
                });
        });

        const mergedAttributeValueArrays = [].concat.apply([], selectedAttributeValueArrays);
        const showMobileSelectedFacets = mergedAttributeValueArrays.length > 0;

        return (
            <div>
                {showMobileSelectedFacets &&
                    <div className="selected-facets row">
                        <div className="filter-by-label">{translateResourceString("/SearchApp/Pagination/FilterByLabel")}</div>
                        {
                            
                            mergedAttributeValueArrays.map((attribute, i) => {
                                return (
                                    <div className="selected-facet" key={i}>
                                        <div className='facet-text'>{attribute.attributeName}: {attribute.attributeValueName}</div> <a onClick={() => onAttributeChange(attribute.attributeName, attribute.attributeValueName)}><i className="fa fa-times-circle" /></a>
                                    </div>
                                );
                            })
                        }
                        <div className="clear"/>
                    </div>
                }
            </div>
        );
    }
}

MobileSelectedFacets.propTypes = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })).isRequired,
    onAttributeChange: PropTypes.func.isRequired,
};

export default MobileSelectedFacets;